import { Menu, MenuItem } from '@mui/material';
import { RightClickMenuMouseEvent } from './hooks/useRightClickMenu';
import { useTranslation } from 'react-i18next';

interface Props {
    componentId: string;
    contextMenu: RightClickMenuMouseEvent | null;
    handleClose: () => void;
    bringToFront?: (componentId: string) => void;
    bringToBack?: (componentId: string) => void;
    copyComponent?: (componentId: string) => void;
    pasteComponent?: (componentId: string) => void;
    undo?: (componentId: string) => void;
    redo?: (componentId: string) => void;
}

export const RightClickMenu: React.FC<Props> = ({ componentId, contextMenu, handleClose, bringToFront, bringToBack, copyComponent, pasteComponent, undo, redo }) => {
    const { t } = useTranslation();

    const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPod|iPad/.test(navigator.platform);

    return (
        <Menu
            open={contextMenu !== null}
            onClose={handleClose}
            anchorReference='anchorPosition'
            anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
        >
            <MenuItem
                disabled={!undo}
                onClick={() => {
                    undo?.(componentId);
                    handleClose();
                }}
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    minWidth: 200,
                }}
            >
                <span>{t('editor.menu.undo')}</span>
                <span style={{ marginLeft: '24px', opacity: 0.6, fontSize: '0.875rem' }}>{isMac ? '⌘+Z' : 'Ctrl+Z'}</span>
            </MenuItem>

            <MenuItem
                disabled={!redo}
                onClick={() => {
                    redo?.(componentId);
                    handleClose();
                }}
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    minWidth: 200,
                }}
            >
                <span>{t('editor.menu.redo')}</span>
                <span style={{ marginLeft: '24px', opacity: 0.6, fontSize: '0.875rem' }}>{isMac ? '⌘ + Shift + Z' : 'Ctrl + Shift + Z'}</span>
            </MenuItem>

            {copyComponent && (
                <MenuItem
                    onClick={() => {
                        copyComponent(componentId);
                        handleClose();
                    }}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        minWidth: 200,
                    }}
                >
                    <span>{t('editor.menu.copy')}</span>
                    <span style={{ marginLeft: '24px', opacity: 0.6, fontSize: '0.875rem' }}>{isMac ? '⌘+C' : 'Ctrl+C'}</span>
                </MenuItem>
            )}
            {pasteComponent && (
                <MenuItem
                    onClick={() => {
                        pasteComponent(componentId);
                        handleClose();
                    }}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        minWidth: 200,
                    }}
                >
                    <span>{t('editor.menu.paste')}</span>
                    <span style={{ marginLeft: '24px', opacity: 0.6, fontSize: '0.875rem' }}>{isMac ? '⌘+V' : 'Ctrl+V'}</span>
                </MenuItem>
            )}
            {bringToFront && (
                <MenuItem
                    onClick={() => {
                        bringToFront?.(componentId);
                        handleClose();
                    }}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        minWidth: 200,
                    }}
                >
                    <span>{t('editor.menu.bringToFront')}</span>
                    <span style={{ marginLeft: '24px', opacity: 0.6, fontSize: '0.875rem' }}>{'Ctrl+]'}</span>
                </MenuItem>
            )}
            {bringToBack && (
                <MenuItem
                    onClick={() => {
                        bringToBack?.(componentId);
                        handleClose();
                    }}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        minWidth: 200,
                    }}
                >
                    <span>{t('editor.menu.bringToBack')}</span>
                    <span style={{ marginLeft: '24px', opacity: 0.6, fontSize: '0.875rem' }}>{'Ctrl+['}</span>
                </MenuItem>
            )}
        </Menu>
    );
};
